import React from 'react';

const ResultsScreen = ({ gameState, onStartGame, onShowStartScreen }) => {
  const isNewBest = gameState.score > gameState.bestScore;

  return (
    <div className="screen results-screen">
      <div className="results-container">
        {/* Simple Game Over Title */}
        <div className="game-over-title">
          <h1>Game Over</h1>
          {isNewBest && <div className="new-best-badge">New Best!</div>}
        </div>
        
        {/* Score Section */}
        <div className="score-section">
          <div className="final-score">
            <span className="score-label">Score</span>
            <span className="score-value">{gameState.score}</span>
          </div>
        </div>
        
        {/* Stats Row */}
        <div className="stats-row">
          <div className="stat">
            <span className="stat-value">{gameState.citreaSlashed || 0}</span>
            <span className="stat-label">Tokens Slashed</span>
          </div>
          <div className="stat">
            <span className="stat-value">{gameState.maxCombo || 0}</span>
            <span className="stat-label">Max Combo</span>
          </div>
          <div className="stat">
            <span className="stat-value">{gameState.bestScore || 0}</span>
            <span className="stat-label">Best Score</span>
          </div>
        </div>
        
        {/* Buttons */}
        <div className="button-row">
          <button 
            className="game-button play-again" 
            onClick={onStartGame}
          >
            Play Again
          </button>
          <button 
            className="game-button back-home" 
            onClick={onShowStartScreen}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultsScreen;